import { AppState } from "../appState";

// Base selector to access commodity state
export const commoditySelector = (state: AppState) => state.commodityMasterData;

